import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const CardSearch = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Footer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-end;

  div {
    width: 200px;
  }
`;
export const ContainerPagination = styled.div`
display: flex;
justify-content: center;

`;
export const ContainerLoading = styled.div`
display: flex;
justify-content: center;`;

export const CardUser = styled.div`
  display: flex;
  height: 90px;
  flex: 1;
  flex-direction: row;
  width: 100%;
`;
export const CardPhoto = styled.div`
  display: flex;
  align-items: center;
  height: 80px;
  margin-left: 8px;
  width: 80px;
`;

export const CardNome = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  word-break: break-all;
`;
export const CardEmail = styled.div`
  display: flex;
  width: 200px;
  word-break: break-all;
  align-items: center;
`;
export const CardSigla = styled.div`
  display: flex;
  width: 140px;
  justify-content: center;
  align-items: center;
`;
export const CardRegional = styled.div`
  display: flex;
  flex-direction: column;
  width: 120px;
  word-break: break-all;
  align-items: center;
  justify-content: center;
`;
export const CardUserActive = styled.div`
  display: flex;
  width: 200px;
  word-break: break-all;
  align-items: center;
  justify-content: space-around;
`;
export const CardUserOption = styled.div`
  display: flex;
  width: 200px;
  word-break: break-all;
  align-items: center;
  justify-content: center;
`;
export const CardPermission = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  justify-content: center;
  align-items: flex-start;
`;
export const Text = styled.div`
  color: #333;
  font-size: 14px;
  margin-left: 5px;
`;
export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  border-radius: 6px;
`;
export const RowCheck = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;
export const Img: any = styled.img`
  height: 16px;
  margin-right: 9.85px;
  margin-left: 8px;
  margin-right: 8px;
`;
export const LabelWithIcon: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    font-size: 12px;
    font-family: Inter;
  }
`;
export const SelectContainer = styled.div`
  display: flex;
  width: 70%;
`;
export const SelectContainerRight = styled.div`
  display: flex;
  width: 25%;
  align-items: flex-start;
`;
export const RowCheckVisit: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;

  div {
    font-family: Inter;
    font-size: 14px;
  }
`;
export const SizedBox = styled.div`
  margin-top: 30px;
`;
